import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/user-icon.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-77c68256"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "seller-testimonials" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h2 class=\"section-title\" data-v-77c68256>Отзывы продавцов</h2><div class=\"testimonial-cards\" data-v-77c68256><div class=\"testimonial-card\" data-v-77c68256><div class=\"testimonial-header\" data-v-77c68256><img src=\"" + _imports_0 + "\" alt=\"Ирина\" class=\"avatar\" data-v-77c68256><div data-v-77c68256><strong data-v-77c68256>Ирина</strong><p data-v-77c68256>Транспортная компания</p></div></div><p class=\"testimonial-text\" data-v-77c68256> Очень удобно, что можно показать прайс и сразу вести чат с клиентом. Сделали 2 сделки за первую неделю. </p></div><div class=\"testimonial-card\" data-v-77c68256><div class=\"testimonial-header\" data-v-77c68256><img src=\"" + _imports_0 + "\" alt=\"Михаил\" class=\"avatar\" data-v-77c68256><div data-v-77c68256><strong data-v-77c68256>Михаил</strong><p data-v-77c68256>Поставщик строительного</p></div></div><p class=\"testimonial-text\" data-v-77c68256> До X-Global мы теряли клиентов из-за недоверия. Теперь с бейджем — заявки идут напрямую. </p></div></div>", 2)
const _hoisted_5 = {
  key: 0,
  class: "promo-block"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " Будьте среди первых 100 компаний — получите продвижение бесплатно! ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "cta-button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#authModal"
}, " Зарегистрироваться бесплатно ", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

import { computed } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewsSection',
  setup(__props) {

const store = useStore();
const loggedIn = computed(() => store.state.auth.status.loggedIn);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!loggedIn.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})